import * as Sentry from "@sentry/vue";
import { useSessionStore } from "@/stores/sessionStore";

class ApplicationError extends Error {
    constructor(message, params, error) {
        super(message);

        Sentry.setTag("hubsynch_id", useSessionStore().session_data.hubsynch_id ?? null);
        Sentry.captureException(error, {
            extra: {
                params: params,
            },
        });
    }
}

export default ApplicationError;